import styles from './breadcrumbs.module.css';

import Head from 'next/head';
import { JsonLd } from 'react-schemaorg';
import { BreadcrumbList, ListItem } from 'schema-dts';

import { Breadcrumb } from 'core/entities/breadcrumb';

import { BreadcrumbItem } from 'components/common/breadcrumbs/breadcrumb-item/breadcrumb-item';

interface BreadcrumbsProps {
  breadcrumbs: Array<Breadcrumb>;
  host?: string;
}

const renderSchema = ({ breadcrumbs, host }: BreadcrumbsProps) => {
  // Создаем объекты для изображений согласно спецификации Schema.org
  const breadcrumbSchema: BreadcrumbList = {
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, index) => {
      const listItem: ListItem = {
        '@type': 'ListItem',
        position: index + 1,
        name: breadcrumb.title
      };
      if (breadcrumb.slug) {
        listItem.item = `https://${host || 'kvartirka.com'}${breadcrumb.slug}`;
      }
      return listItem;
    })
  };

  return (
    <Head>
      <JsonLd<BreadcrumbList>
        item={{
          '@context': 'https://schema.org',
          ...breadcrumbSchema
        }}
      />
    </Head>
  );
};

export function Breadcrumbs({ breadcrumbs }: BreadcrumbsProps) {
  return (
    <nav>
      {renderSchema({ breadcrumbs })}
      <ul className={styles.root}>
        {breadcrumbs.map((breadcrumb, index) => (
          <BreadcrumbItem key={breadcrumb.title} breadcrumb={breadcrumb} index={index} />
        ))}
      </ul>
    </nav>
  );
}
